import { render, staticRenderFns } from "./VueJSONEditor.vue?vue&type=template&id=d52795fa&scoped=true&"
import script from "./VueJSONEditor.vue?vue&type=script&lang=js&"
export * from "./VueJSONEditor.vue?vue&type=script&lang=js&"
import style0 from "./VueJSONEditor.vue?vue&type=style&index=0&id=d52795fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52795fa",
  null
  
)

export default component.exports